import React from "react";
import { Link } from "react-router-dom";
import CTAButton from "../CTAButton/CTAButton";
import "./ToolPage.css";
import builderImage from "../../assets/feature-image.png";
import audienceImage from "../../assets/signup.png";
import automationImage from "../../assets/automation flow.png";
import segmentationImage from "../../assets/segment.png";

const TOOL_CONTENT = {
  builder: {
    eyebrow: "Email builder",
    title: "Design polished emails without code",
    text: "Start with templates, customize every block, and prepare responsive campaigns for every inbox.",
    image: builderImage,
    alt: "Email builder preview",
    bullets: ["Drag-and-drop content blocks", "Reusable brand sections", "Mobile-ready campaign previews"],
  },
  audience: {
    eyebrow: "Audience tools",
    title: "Grow and organize your subscriber list",
    text: "Create signup forms, capture leads, and keep your contacts ready for targeted campaigns.",
    image: audienceImage,
    alt: "Audience signup form preview",
    bullets: ["Embedded signup forms", "Landing page capture", "Import and organize contacts"],
  },
  automation: {
    eyebrow: "Automation builder",
    title: "Build journeys that run on autopilot",
    text: "Create welcome flows, follow-ups, and subscriber journeys that send at the right moment.",
    image: automationImage,
    alt: "Automation flow preview",
    bullets: ["Welcome sequences", "Trigger-based follow-ups", "Journey performance tracking"],
  },
  segmentation: {
    eyebrow: "Segmentation tools",
    title: "Send the right message to the right people",
    text: "Use tags, engagement, and profile data to tailor campaigns for each audience group.",
    image: segmentationImage,
    alt: "Segmentation preview",
    bullets: ["Smart subscriber groups", "Tag-based targeting", "Personalized campaign content"],
  },
};

export default function ToolPage({ type }) {
  const content = TOOL_CONTENT[type] || TOOL_CONTENT.builder;

  return (
    <div className="tool-page">
      <section className="tool-hero">
        <div className="tool-copy">
          <Link to="/features" className="back-link">← Back to features</Link>
          <span>{content.eyebrow}</span>
          <h1>{content.title}</h1>
          <p>{content.text}</p>
          <div className="tool-actions">
            <CTAButton>Get started</CTAButton>
            <CTAButton kind="templates" className="secondary-btn">Explore templates</CTAButton>
          </div>
        </div>
        <div className="tool-visual">
          <img src={content.image} alt={content.alt} width="640" height="420" />
        </div>
      </section>

      <section className="tool-feature-list">
        {content.bullets.map((item) => (
          <article key={item}>
            <strong>{item}</strong>
            <p>Simple, responsive, and ready for real campaign workflows.</p>
          </article>
        ))}
      </section>
    </div>
  );
}
